import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

// Phase 3.7 Tier 5 — partner training walkthrough show page.
//
// Single job: fire "Partner Walkthrough Viewed" exactly once on
// connect. We don't track watch-time / completion — those signals
// belong to the embed provider (Loom / YouTube / Wistia), not us.
export default class extends Controller {
  static values = {
    slug: String,
    category: String,
    title: String
  }

  connect() {
    track("Partner Walkthrough Viewed", {
      slug: this.slugValue,
      category: this.categoryValue,
      title: this.titleValue
    })
  }
}
